import { render, staticRenderFns } from "./MobileDropdownMenuOverlay.vue?vue&type=template&id=1440a41c"
import script from "./MobileDropdownMenuOverlay.vue?vue&type=script&lang=js"
export * from "./MobileDropdownMenuOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DropdownMenuList: require('/home/runner/work/platform/platform/packages/client/src/components/elements/base/dropdown-menu-list/DropdownMenuList.vue').default})
